var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Opening a survey"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", { staticClass: "lead" }, [
                    _vm._v(
                      "\n                        You're about to open the survey.\n                    "
                    ),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("table", { staticClass: "table" }, [
                    _c("tbody", [
                      _c("tr", [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("td", { staticClass: "align-middle" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary btn-block text-nowrap",
                              on: { click: _vm.showAccessLinks },
                            },
                            [_vm._v("Access links")]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.startSurvey },
                    },
                    [_vm._v("Open the survey")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("h5", [_vm._v("Access links")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "These links will let your respondents access the survey with just one click. Why not (re)send them now?​"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }